import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';

const NormalInputGuideBlock = styled.div`
    position: relative;
`;

const NormalGuideInputBlock = styled.input`
    height: 40px;
    width: 100%;
    padding: 0 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    margin-bottom: ${props => props.marginBottom || '0px'};

    &:focus {
        border: 1px solid #ffc742;
        outline: 0
    }

    ::-webkit-input-placeholder {
        color: #ccc
    }

    ::-moz-placeholder {
        color: #ccc
    }

    ::-ms-input-placeholder {
        color: #ccc
    }

    ::placeholder {
        color: #ccc
    }
    :focus {
        outline: 0
    }
`;

const NormalInputBtnSpanBlock = styled.span`
    display: none;
    position: absolute;
    top: 26px;
    right: -35px;
    width: 290px;
    line-height: 20px;
    background-color: #ffc742;
    border-radius: 10px;
    font-size: 12px;
`;

const NormalInputBtnBlock = styled.button`
    position: absolute;
    top: 8px;
    right: 15px;
    width: 22px;
    height: 22px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;

    &:hover ${NormalInputBtnSpanBlock} {
        display: block;
    }
`;

const NormalInputSpanBlock = styled.span`
    display: ${props => props.dispError ? 'block' : 'none'};
    margin-top: 5px;
    margin-left: 30px
    line-height: 20px;
    font-size: 12px;
    color: #f80053;
`;

const NormalInputGuide = ({ type, maxLength,
    placeholder, marginBottom, onChange, guide, onBlur, onFoucs,
    dispError, errText, disabled, value }) => {

    var setting = {
        type: type,
        maxLength: maxLength,
        placeholder: placeholder,
        onChange: onChange,
        marginBottom: marginBottom,
        focusBorder: dispError ? '1px solid #f80053' : '1px solid #ffc742',
        disabled: disabled,
        value: value
    }

    const handeBlur = () => {
        // console.log("handeBlur ++++++++");
        onBlur();
    }

    const handleFocus = () => {
        // console.log("handleFocus ------>")
        onFoucs();
    }

    return (
        <NormalInputGuideBlock>
            <NormalGuideInputBlock {...setting}
                onBlur={() => { handeBlur() }}
                onFocus={() => { handleFocus() }} />
            <NormalInputBtnBlock
                img="/assets//images/icon/answer-icon.png">
                <NormalInputBtnSpanBlock>{guide}</NormalInputBtnSpanBlock>
            </NormalInputBtnBlock>
            <NormalInputSpanBlock dispError={dispError}>{errText}</NormalInputSpanBlock>
        </NormalInputGuideBlock>
    );
};

export default NormalInputGuide;